import { render } from "./PlanillaResumen.vue?vue&type=template&id=b21e455e&scoped=true"
import script from "./PlanillaResumen.vue?vue&type=script&lang=js"
export * from "./PlanillaResumen.vue?vue&type=script&lang=js"

import "./PlanillaResumen.vue?vue&type=style&index=0&id=b21e455e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b21e455e"]])

export default __exports__